import { paths, routes } from 'pages/origin/routes';
import api from 'resources/origin/api';
import lazyWithRetry from 'services/lazyWithRetry';
import selectors from 'store/origin/selectors';
import { actions } from 'store/origin/slice';
import { OriginApiItem } from 'typings/api';
import { Resource } from 'typings/shared';

const resource: Resource<OriginApiItem, typeof paths, typeof api, typeof actions, typeof selectors, typeof routes> = {
    name: 'origin',
    translationKey: 'origin',
    api,
    selectors,
    paths,
    routes,
    actions,
    component: lazyWithRetry(() => import('pages/origin')),
};

export default resource;
